import React from "react";
import { ProbationQuestion } from "../schemas/index.ts";
import TextFieldRenderer from "./text-field-renderer.tsx";
import ChoiceFieldRenderer from "./choice-field-renderer.tsx";
import CheckboxFieldRenderer from "./checkbox-field-renderer.tsx";

interface QuestionRendererProps {
    question: ProbationQuestion;
    field: any;
    index?: number;
}

export function QuestionRenderer({ question, field, index }: QuestionRendererProps) {
    const isReadOnly = !question.editable;

    switch (question.questionType) {
        case "TEXT":
            return <TextFieldRenderer question={question} field={field} readOnly={isReadOnly} index={index} />;

        case "RATING":
            return <ChoiceFieldRenderer question={question} field={field} readOnly={isReadOnly} index={index} />;

        case "RADIO":
            return <ChoiceFieldRenderer question={question} field={field} readOnly={isReadOnly} index={index} />;

        case "CHECKBOX":
            return <CheckboxFieldRenderer question={question} field={field} readOnly={isReadOnly} index={index} />;
            
        default:
            return <div>Unsupported question type, Please contact the administrator.</div>;
    }
}